import { memo, useContext, useState, useEffect, useRef } from "react";
import {
  Button,
  Text,
  Flex,
} from "@pancakeswap/uikit";
import {
  CopyOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import {
  spenToken,
  privatekeyArrayChange,
  privatekeyArray,
  pairToken,
  token,
  router,
  feeV3,
  chainId,
  rpc,
  v3Factory,
  quoter,
  poolChange,
  vip,
  swapType,
} from "@/store";
import { addressHand, approve, isMainAddress } from "@/utils";
import { useChainId } from "wagmi";
import {
  SENDERTOKENCONTRACT,
} from "@/config";
import copyHandler from "@/utils/copy";
import { AppContext } from "@/context";
import PrivetakeyManger from "./PrivetakeyManger";
import {
  FooterSwapper,
  FooterContent,
  FooterItem,
  ItemHeader,
  Item,
  FooterTotal,
  WalletBtn,
} from "./style";
import {
  useWeb3React,
} from "@/hooks";

import { Notification } from "@/components";
import { chains, wagmiConfig } from "@/utils/wagmi";
import ModelInput from "@/components/ModelInput";
import ModelInput1 from "@/components/ModelInput/index1";
import { getWalletList } from "@/utils/getWalletList";
import { colllectETHHandler, colllectTokenHandler } from "@/utils/getCollect";
import Web3 from "web3";
import senderTokenAddressHandler from "@/utils/sender";
import exportToExcel from "@/utils/downExcel";
import { WalletType } from "@/views/CreateWallet";
import { getPrice } from "@/utils/getPrice";
import copy from "copy-to-clipboard";
import { swapHandle } from "@/views/MarKetBot/executeSwap";
import SellSvg from "@/components/SVG/SellSvg";
import BuySvg from "@/components/SVG/BuySvg";
import Delete from "@/components/SVG/Delete";
import axios from "axios";
import { useWalletInfoContext } from "@/context/WalletInfoContext";
import { privateKeyToAccount } from "viem/accounts";
import { createWalletClient, http } from "viem";
import { isContractAddress } from "@/utils/isContractAddress";
import { to0xString } from "@/utils/toHex";
import { LineStyle } from "../Content/style";
import { FormLabel } from "../Header/style";
import { formatAmount } from "@/utils/formatAmount";

interface FooterColumn<T = any> {
  header: string;
  data: T[];
  render: (index: number, item: T) => JSX.Element | null;
}

function App() {
  const dispatch = useDispatch();
  const { Lang } = useContext(AppContext);
  const _spenToken = useSelector(spenToken);

  const _privatekeyArray = useSelector(privatekeyArray);
  const { account, provider, walletClient } = useWeb3React();
  const _chainId = useSelector(chainId);


  const {
    walletAddrArr,
    walletConfig,
    totalConfig,
    getWalletInfo,
    getAllowance,
    tokenIsA,
  } = useWalletInfoContext();



  const _token = useSelector(token);
  const _feeV3 = useSelector(feeV3);

  const [isSell, setIsSell] = useState([]);
  const [BuyLoading, setBuyLoading] = useState([]);
  useEffect(() => {
    if (walletConfig.TOKENbArr) {
      const _sell = [];
      walletConfig.TOKENbArr.forEach((item) => {
        _sell.push(false);
      });
      setIsSell(_sell);
    }
  }, [walletConfig]);
  const removeWallet = (index: number) => {
    const arr = [..._privatekeyArray];
    arr.splice(index, 1);
    dispatch(privatekeyArrayChange(arr));
  };
  // const provider = useProviderInstance();

  const _router = useSelector(router);
  const _v3Factory = useSelector(v3Factory);
  const _quoter = useSelector(quoter);


  const _swapType = useSelector(swapType);
  const executeSwapSingle = swapHandle();

  const click = async (
    index: number,
    isBuy: boolean,
    val?: { value: string; extraValue: string },
  ) => {
    try {
      if (isBuy) {
        const _ise3 = [...BuyLoading];
        _ise3[index] = true;
        setBuyLoading(_ise3);
      } else {
        const _ise = [...isSell];
        _ise[index] = true;
        setIsSell(_ise);
      }

      const result = await getPrice(
        provider,
        _token,
        _spenToken,
        _router,
        _chainId,
        Number(_feeV3),
        _v3Factory,
        _swapType,
        dispatch,
      );

      if (!result.WETHToken) {
        const _ise1 = [...isSell];
        _ise1[index] = false;
        setIsSell(_ise1);
        const _ise3 = [...BuyLoading];
        _ise3[index] = false;
        setBuyLoading(_ise3);
        return Notification.Error("请先查池子");
      }
      dispatch(poolChange(result));
      if (isBuy) {
        await executeSwapSingle(
          index,
          true,
          val.value,
          val.extraValue,
          result.WETHToken,
          result.arr,
        );
      } else {
        await executeSwapSingle(
          index,
          false,
          '0',
          "",
          result.WETHToken,
          result.arr,
        );
      }

    } catch (error) {
      console.log(error, "error");
      // message.error(error.toString())
      Notification.Error(error.toString());
    }
    if (isBuy) {
      const _ise2 = [...BuyLoading];
      _ise2[index] = false;
      setBuyLoading(_ise2);
    } else {
      const _ise1 = [...isSell];
      _ise1[index] = false;
      setIsSell(_ise1);
    }
    getWalletInfo();
  };

  const [isShowPriveKeyPage, setIsShowPriveKeyPage] = useState(false);

  const exportHandle = () => {
    if (walletArr.length !== 0) {
      console.log(walletArr.length);
      exportToExcel(walletArr);
    } else {
      const wallets = _privatekeyArray.map((pk) => {
        // 使用 viem 从私钥创建账户
        const account = privateKeyToAccount(`0x${pk.replace('0x', '')}`);
        return {
          address: account.address,
          mnemonic: "无法从私钥还原助记词", // viem 不支持从私钥获取助记词
          privateKey: pk,
        };
      });
      exportToExcel(wallets);
    }
    Notification.Success("导出成功");
  };
  const btnClick = () => {
    // console.log(_token, '_token');
    if (!_token?.address) return Notification.Error("请先输入代币地址");
    setIsShowPriveKeyPage(true);
  };
  const hidePriveKeyPage = () => {
    setIsShowPriveKeyPage(false);
  };
  // 返回一个长度与 walletAddrArr 一样的数组，填充默认值
  const nativeSymbol =
    chains?.find((c) => c.id === _chainId)?.nativeCurrency?.symbol || "";

  const spendSymbol = _spenToken?.symbol ?? "基础代币";

  const isSameBalanceColumn =
    nativeSymbol &&
    spendSymbol &&
    nativeSymbol === spendSymbol;
  const footerColumns: FooterColumn[] = [
    {
      header: "序号",
      render: (index) => <div>{index + 1}</div>,
      data: Array.from({ length: walletAddrArr.length }, (_, i) => i),
    },
    {
      header: Lang.WalletAddress + "(" + walletAddrArr.length + ")",
      render: (index: number, item: string) => (
        <Flex justifyContent="center" alignItems="center">
          <FormLabel>{addressHand(item)}</FormLabel>
          <CopyOutlined onClick={() => copyHandler(item)} />
        </Flex>
      ),
      data: walletAddrArr,
    },
    {
      header: `${nativeSymbol} ${Lang.balance}`,
      render: (_: number, item: number) => (
        <FormLabel>{formatAmount(item)}</FormLabel>
      ),
      data: safeArray(walletConfig?.BNBbArr, "0", walletAddrArr.length),
    },
    ...(!isSameBalanceColumn
      ? [
        {
          header: `${spendSymbol} ${Lang.balance}`,
          render: (_: number, item: number) => (
            <FormLabel>{formatAmount(item)}</FormLabel>
          ),
          data: safeArray(walletConfig?.SPENTOKENbArr, "0", walletAddrArr.length),
        },
      ]
      : []),

    ...(_token?.address
      ? [
        {
          header: `${_token?.symbol} ${Lang.balance}`,
          render: (_: number, item: number) => (
            <FormLabel>{formatAmount(item)}</FormLabel>
          ),
          data: safeArray(walletConfig?.TOKENbArr, "0", walletAddrArr.length),
        },
        {
          header: Lang.c10,
          render: (index: number) => <FormLabel>{tokenIsA[index] ? "YES" : "NO"}</FormLabel>,
          data: safeArray(walletConfig.TOKENbArr, "NO", walletAddrArr.length),
        },
      ]
      : []),


    {
      header: Lang.c8,
      render: (index: number) => (

        <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
          {BuyLoading[index] ? (
            <div>
              <LoadingOutlined />
            </div>
          ) : (
            <div
              onClick={() =>
                openModal1({
                  title: "买入参数设置",
                  handleOks: (val) => {
                    if (
                      typeof val === "object" &&
                      (Number(val.extraValue) < 0 ||
                        Number(val.extraValue) > 100)
                    )
                      return Notification.Error("滑点设置应在0-100");
                    click(index, true, val as any);
                  },
                  type: 1,
                  confirm: "买入",
                })
              }
            >
              <BuySvg />
            </div>
          )}
          {isSell[index] ? (
            <div>
              <LoadingOutlined />
            </div>
          ) : (
            <div onClick={() => click(index, false)}>
              <SellSvg />
            </div>
          )}

          <div onClick={() => removeWallet(index)}>
            <Delete />
          </div>
        </div>
      ),
      data: safeArray(walletConfig.TOKENbArr, "1", walletAddrArr.length),
    },
  ];

  const [modalInfo, setModalInfo] = useState<ModalInfo | null>(null);
  const [modalInfo1, setModalInfo1] = useState<ModalInfo1 | null>(null);
  const [modalInfo2, setModalInfo2] = useState<ModalInfo2 | null>(null);
  const openModal = (config: ModalInfo) => {
    setModalInfo({
      title: config.title,
      type: config.type,
      handleOk: config.handleOk,
      msg: config.msg,
      confirm: config.confirm,
      account: config.account,
    });
  };
  const openModal1 = (config: ModalInfo1) => {
    setModalInfo1({
      title: config.title,
      type: config.type,
      handleOks: config.handleOks,
      msg: config.msg,
      confirm: config.confirm,
      account: config.account,
    });
  };
  const openModal2 = (config: ModalInfo2) => {
    setModalInfo2({
      title: config.title,
      handleOks: config.handleOks,
      msg: config.msg,
      confirm: config.confirm,
      account: config.account,
    });
  };

  const closeModal = () => {
    setModalInfo(null);
    setModalInfo1(null);
    setModalInfo2(null);
  };

  const [walletArr, setWalletArr] = useState<WalletType[]>([]);

  async function CreateWallet(i: number) {
    try {
      const res = await getWalletList(i);

      if (res.length !== 0) {
        const data = res.map((w) => w.privateKey);

        dispatch(privatekeyArrayChange(data));
        setWalletArr(res);
        return data;
      }
    } catch (err) {
      console.log(err, "err");
    }
  }

  const batchTradeRef = useRef(null);
  const _privaKeyArr = useSelector(privatekeyArray);
  const _rpc = useSelector(rpc);
  const web3 = new Web3(_rpc);
  const chainIds = useChainId();
  const [senderTotalNumber, setSenderTotalNumber] = useState(0); // 发送总次数
  const [sendingIndex, setSendingIndex] = useState<number | null>(null);
  const [collectIndex, setCollectIndex] = useState<number | null>(null);
  useEffect(() => {
    const _totalNumber = Math.ceil(_privaKeyArr.length / 200);
    setSenderTotalNumber(_totalNumber);
  }, [_privaKeyArr]);

  const currentChain = chains.find(c => c.id === _chainId);

  const _vip = useSelector(vip);
  const senderHandle = async (
    val: string | { value: string; extraValue: string },
    boolean: boolean,
    tokenInfo: { address: string; decimals: number },
  ) => {
    // 如果发送主链代币
    if (chainIds && (chainIds) != _chainId) {
      Notification.Error("请切换正确的链");
      return;
    }
    if (
      chainIds &&
      !(await isContractAddress(SENDERTOKENCONTRACT[chainIds], provider))
    ) {
      Notification.Error("当前地址不是合约地址");
      return;
    }

    let WalletClient = walletClient; // 默认用当前连接的钱包
    let fromAddress: string = account;

    const type = typeof val === "string";
    const amountStr = type ? val : val.value;
    const acc = type ? val : val.extraValue;
    if (_privaKeyArr.length === 0) {
      return Notification.Error("没有导入钱包，无法执行发送");
    }
    if (acc) {
      const formattedPk = acc.startsWith('0x') ? acc : `0x${acc}`;
      const accountFromPk = privateKeyToAccount(to0xString(formattedPk));
      // 创建 walletClient（如果还没有的话）
      WalletClient = createWalletClient({
        account: accountFromPk,
        transport: http(_rpc),
        chain: currentChain
      }) as any

      fromAddress = accountFromPk.address;
    }

    const amount = Number(amountStr);
    console.log(amount, "amount", isNaN(amount));
    if (!amount || isNaN(amount)) {
      return Notification.Error("数量不合法");
    }
    console.log('boolean::: ', boolean);

    try {
      if (!boolean) {
        await approve(
          fromAddress,
          tokenInfo.address,
          Math.ceil(amount * _privaKeyArr.length),
          SENDERTOKENCONTRACT[_chainId],
          tokenInfo.decimals,
          WalletClient
        );
      }
      senderTokenAddressHandler({
        chainId: _chainId,
        walletClient: WalletClient,
        publicClient: provider,
        tokenInfo,
        tokens: walletAddrArr,
        amounts: new Array(_privaKeyArr.length).fill(amount.toString()),
        senderBase: 200,
        senderTotalNumber,
        isMainAddress: boolean,
        isVip: _vip,
      });
    } catch (err) {
      console.log(err, "err");
    }
  };

  // 改造后的 totals 数组（统一使用对象传参调用 openModal）
  const totals = [
    // 第一列
    {
      label: `${chains?.find((c) => c.id === _chainId)?.nativeCurrency?.symbol || ""} ${Lang.Total}`,
      value: totalConfig.bnbTotal,
      token: "BNB",
      // 第一个 openModal：已改为对象传参（保持原有逻辑）
      click: () =>
        openModal({
          title: "输入归集接收钱包地址",
          type: 2,
          msg: ["确认接收钱包地址正确"],
          handleOk: async (val) => {
            setCollectIndex(0);
            await colllectETHHandler(
              _privaKeyArr,
              web3,
              val as string,
              _chainId,
              (i, hash) => {
                console.log(`钱包${i + 1} 归集成功，交易哈希: ${hash}`);
              },
              (i, err) => {
                console.log(`钱包${i + 1} 失败：`, err);
              },
            );
            setCollectIndex(null);
            Notification.Success("归集完成");
          },
        }),
      // 第二个 openModal：从顺序传参改为对象传参
      clicks: () =>
        openModal({
          title: `输入向每个刷单钱包转账的${chains?.find((c) => c.id === _chainId).nativeCurrency?.symbol}数量`,
          type: 1,
          handleOk: async (val) => {
            setSendingIndex(0);
            await senderHandle(val, true, {
              decimals: _spenToken.decimals,
              address: _spenToken?.address,
            });
            setSendingIndex(null);
          },
          account: account,
        }),
    },

    // 第二列
    {
      label: `${_spenToken?.symbol || "基础代币"} ${Lang.Total}`,
      value: totalConfig.usdtTotal,
      token: _spenToken?.symbol,
      // 第一个 openModal：从顺序传参改为对象传参
      click: () =>
        openModal({
          title: "输入归集接收钱包地址",
          msg: ["确认接收钱包地址正确"],
          type: 2,
          handleOk: async (val) => {
            if (_spenToken?.address && isMainAddress(_spenToken?.address)) {
              await colllectETHHandler(
                _privaKeyArr,
                web3,
                val as string,
                _chainId,
                (i, hash) => {
                  console.log(`钱包${i + 1} 归集成功，交易哈希: ${hash}`);
                },
                (i, err) => {
                  console.log(`钱包${i + 1} 失败：`, err);
                },
              );
            } else {
              batchTradeRef.current = new web3.BatchRequest();
              await colllectTokenHandler(
                _privaKeyArr,
                web3,
                {
                  to: val as string,
                  token: _spenToken?.address,
                },
                batchTradeRef,
                _rpc,
                currentChain
              );
            }
            Notification.Success("归集完成");
          },
        }),
      // 第二个 openModal：从顺序传参改为对象传参
      clicks: () =>
        openModal({
          title: `输入向每个刷单钱包转账的${_spenToken?.symbol} 数量`,
          type: 1,
          handleOk: async (val) => {
            if (!_spenToken?.address) return;
            setSendingIndex(1);
            await senderHandle(
              val,
              isMainAddress(_spenToken?.address),
              _spenToken,
            );
            setSendingIndex(null);
          },
          account: account,
        }),
    },

    // 第三列
    ...(_token.address ? [{
      label: `${_token?.symbol} ${Lang.Total}`,
      value: totalConfig.tokenTotal,
      token: "TOKEN",
      // 第一个 openModal：从顺序传参改为对象传参
      click: () =>
        openModal({
          title: "输入归集接收钱包地址",
          msg: ["确认接收钱包地址正确"],
          type: 2,
          handleOk: async (val) => {
            console.log(val, "val");
            setCollectIndex(2);
            batchTradeRef.current = new web3.BatchRequest();
            await colllectTokenHandler(
              _privaKeyArr,
              web3,
              {
                to: val as string,
                token: _token?.address,
              },
              batchTradeRef,
              _rpc,
              currentChain
            );
            setCollectIndex(null);
            Notification.Success("归集完成");
          },
        }),
      // 第二个 openModal：从顺序传参改为对象传参
      clicks: () =>
        openModal({
          title: `输入向每个刷单钱包转账的${_token?.symbol}数量`,
          type: 1,
          handleOk: async (val) => {
            setSendingIndex(2);
            await senderHandle(val, false, _token);
            setSendingIndex(null);
          },
          account: account,
        }),
    }] : [])
  ];
  const [isLoading, setIsLoading] = useState(false);

  const freshHandle = async () => {
    setIsLoading(true);
    const res = await getWalletInfo();
    await getAllowance()
    if (!res) Notification.Error("获取余额失败");
    setIsLoading(false);
  };


  return (
    <FooterSwapper>
      <WalletBtn>
        <Button
          onClick={() => {
            // 第一次 openModal：输入数量（从顺序传参改为对象传参）
            openModal({
              title: "输入数量",
              type: 3,
              msg: [
                "1 生成钱包会覆盖已存在的钱包，并无法找回。请务必保存好已存在的钱包私钥",
                "2 生成的钱包全部缓存在浏览器，一旦浏览器出现问题，私钥无法找回，请务必在本地保存好已存在的钱包私钥",
                "3 请务必保存好已生成的私钥,如有遗失，平台概不负责",
              ],
              handleOk: async (val) => {
                const arr = await CreateWallet(Number(val));
                closeModal();
                setTimeout(() => {
                  // 第二次 openModal：私钥展示（从顺序传参改为对象传参）
                  openModal({
                    title: "私钥展示",
                    type: 0,
                    msg: arr,
                    confirm: "复制", // 自定义确认按钮文本
                    handleOk: (val) => {
                      copy(arr.join("\n"));
                      Notification.Info("复制私钥成功，请立即保存");
                    },
                  });
                }, 0);
              },
            });
          }}
        >
          生成钱包
        </Button>
        <Button onClick={exportHandle}>导出私钥</Button>
        <Button onClick={freshHandle}>
          {Lang.refresh}
          {isLoading && <LoadingOutlined />}
        </Button>
        <Button onClick={btnClick}>{Lang.importwallet}</Button>
      </WalletBtn>
      {isShowPriveKeyPage && (
        <PrivetakeyManger btnCallback={hidePriveKeyPage} />
      )}

      <FooterTotal>
        {totals.map((item, index) => (
          <div className="item" key={index}>
            {/* 第一行：标题 + 按钮组 */}
            <div className="header-row">
              <span className="label">{item.label}</span>

              {item.token && (
                <div className="action-buttons">
                  <div className="btn btn-collect" onClick={item.click}>
                    归集{collectIndex === index && "..."}
                  </div>
                  <div className="btn btn-transfer" onClick={item.clicks}>
                    转账{sendingIndex === index && "..."}
                  </div>
                </div>
              )}
            </div>

            {/* 第二行：数值 */}
            <div className="value-row">
              {item.value}
            </div>
          </div>
        ))}
      </FooterTotal>

      <LineStyle />
      {modalInfo && (
        <ModelInput
          callBack={closeModal}
          handleOks={modalInfo.handleOk}
          title={modalInfo.title}
          type={modalInfo.type}
          msg={modalInfo.msg}
          account={modalInfo.account}
          confirm={modalInfo.confirm}
        />
      )}
      {modalInfo1 && (
        <ModelInput1
          callBack={closeModal}
          handleOks={modalInfo1.handleOks}
          title={modalInfo1.title}
          type={modalInfo1.type}
          msg={modalInfo1.msg}
          confirm={modalInfo1.confirm}
          two={true}

        />
      )}



      <FooterContent>
        {footerColumns.map((col, colIndex) => (
          <FooterItem key={colIndex}>
            <ItemHeader>
              <FormLabel>{col.header}</FormLabel>
            </ItemHeader>
            {col.data.map((item, index) => (
              <Item key={index}>{col.render(index, item)}</Item>
            ))}
          </FooterItem>
        ))}
      </FooterContent>
    </FooterSwapper>
  );
}

export default memo(App);

export const safeArray = (
  arr: any[] | undefined,
  defaultValue: string,
  len: number,
) => {
  if (!arr) return Array(len).fill(defaultValue);
  if (arr.length < len) {
    return [...arr, ...Array(len - arr.length).fill(defaultValue)];
  }
  return arr;
};

export interface ModalInfo {
  title: string;
  type: number;
  handleOk: (val: string | { value: string; extraValue: string }) => void;
  account?: string;
  msg?: string[];
  confirm?: string;
}

export interface ModalInfo1 {
  title: string;
  type: number;
  handleOks: (val: string | { value: string; extraValue: string }) => void;
  account?: string;
  msg?: string[];
  confirm?: string;
}
export interface ModalInfo2 {
  title: string;
  handleOks: (val: { value: string; value1: string; extraValue: boolean }) => void;
  account?: string;
  msg?: string[];
  confirm?: string;
}
